<template>
  <div class="container-block" style="margin: 15px 0">
    <h3>基础信息</h3>
    <a-row>
      <a-col :span="8">
        动物类型：{{details.animalTypeName}}
      </a-col>
      <a-col :span="8">
        配方模型：{{details.formulaModelName}}
      </a-col>
      <a-col :span="8">
        养分选择表：{{details.animalNutritionName}}
      </a-col>
      <a-col :span="8">
        价格来源：{{details.priceSourceName}}
      </a-col>
      <a-col :span="8">
        盘重：{{details.totalWeight}}
      </a-col>
      <a-col :span="8">
        水分挥发：{{details.moistureVolatilizeStart}}
      </a-col>
      <a-col :span="8">
        分析基础：{{details.analysisBase}} {{details.analysisBaseUnit}}
      </a-col>
      <a-col :span="16">
        备注：{{details.remark}}
      </a-col>
    </a-row>
  </div>
</template>


<script>
export default {
  props: ['details'],
  data(){
    return{

    }
  }
}
</script>
